import { render, staticRenderFns } from "./Permit.vue?vue&type=template&id=5cc4e5db&"
import script from "./Permit.vue?vue&type=script&lang=ts&"
export * from "./Permit.vue?vue&type=script&lang=ts&"
import style0 from "./Permit.vue?vue&type=style&index=0&id=5cc4e5db&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports